import { Grid } from "@material-ui/core";
import React from "react";

interface IProp {
  viewCount: string;
  likeCount: string;
  commentCount: string;
}
const YoutubeDataCard = ({ viewCount, likeCount, commentCount }: IProp) => {
  const numberWithCommas = (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={4} md={4}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "16px",
              fontWeight: 900,
              lineHeight: "24px",
            }}
          >
            {numberWithCommas(viewCount)}
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "12px",
            }}
          >
            Views
          </Grid>
        </Grid>
        <Grid item xs={4} md={4}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "16px",
              fontWeight: 900,
              lineHeight: "24px",
            }}
          >
            {numberWithCommas(likeCount)}
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "12px",
            }}
          >
            Likes
          </Grid>
        </Grid>
        <Grid item xs={4} md={4}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "16px",
              fontWeight: 900,
              lineHeight: "24px",
            }}
          >
            {numberWithCommas(commentCount)}
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{
              color: "#000",
              fontFamily: "Avenir",
              fontSize: "12px",
            }}
          >
            Comments
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default YoutubeDataCard;
